import {
  protectedDeleteWithBody,
  protectedGet,
  protectedPatch,
  protectedPost,
} from "./restUtil";
import { ServerErrorResponse } from "../model/general";
import { Notification } from "model/notification";

export function getNotifications(
  _: void,
  onSuccess: (res: { list: Notification[] }) => void,
  onError: (errors: ServerErrorResponse) => void
) {
  return protectedGet("/notifications", undefined, onSuccess, onError);
}

export function getSettingsNotifications(
  onSuccess: (res: {
    engagement: boolean;
    marketing: boolean;
    reminders: boolean;
    system: boolean;
  }) => void,
  onError: (errors: ServerErrorResponse) => void
) {
  return protectedGet("/settings/notifications", undefined, onSuccess, onError);
}

export function patchSettingsNotifications(
  args: any,
  onSuccess: () => void,
  onError: (errors: ServerErrorResponse) => void
) {
  return protectedPatch("/settings/notifications", args, onSuccess, onError);
}

export function postNotificationsRead(
  args: { notifications: string[] },
  onSuccess: (res: { notifications: string[] }) => void,
  onError: (errors: ServerErrorResponse) => void
) {
  return protectedPost("/notifications/read", args, onSuccess, onError);
}

export function deleteNotifications(
  args: { notifications: string[] },
  onSuccess: (res: { notifications: string[] }) => void,
  onError: (errors: ServerErrorResponse) => void
) {
  return protectedDeleteWithBody("/notifications", args, onSuccess, onError);
}

export function isHighSeverityNotification(notification: Notification) {
  return notification.type === "team_member_forfeited";
}
